module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_4_3_w_400.b5b5033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_4_3_w_400.jpg
// module id = 1m/J
// module chunks = 0